import { AuthoritiesType } from '@/types/Authority';
import { getUserFromLocalStorage } from '@/utils/user';
import jwtDecode from 'jwt-decode';

export enum AuthModule {
  'ON' = 'ON',
  'PLUS' = 'PLUS',
  'MASTER' = 'MASTER',
}

interface JWT {
  authorities?: AuthoritiesType[];
  client_id: string;
  companyIds: number[];
  email: string;
  employeeId: number;
  exp: number;
  jti: string;
  matrixId: number;
  scope: string[];
  userId: number;
  user_name: string;
  roles: string[];
  module: AuthModule;
}

export default function useSession() {
  const { accessToken } = getUserFromLocalStorage();

  if (!accessToken) return null;

  return jwtDecode<JWT>(accessToken);
}
